import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=4ad8ef14&scoped=true&"
import script from "./Tech.vue?vue&type=script&lang=ts&"
export * from "./Tech.vue?vue&type=script&lang=ts&"
import style0 from "./Tech.vue?vue&type=style&index=0&id=4ad8ef14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad8ef14",
  null
  
)

export default component.exports